import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-radv-report-dw",
  templateUrl: "./radv-report-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadvReportDwComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.RADV_DASHBOARD;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID, HideFilters.CUSTOMER_NAME,
                           HideFilters.STATUS, HideFilters.CONTACT_METHOD_STATUS, HideFilters.PROJECT_NAME, HideFilters.PROJECT_TYPE_ID,
                           HideFilters.DOCUMENT_STATE]    ;
}
